module.exports = __webpack_public_path__ + "src/assets/sv.5440e7fa.png";